export const ItemRarityEnum = {
  0: "COMMON",
  1: "UNCOMMON",
  2: "RARE",
  3: "EPIC",
  4: "LEGENDARY",
  5: "MYTHIC",
  6: "TRANSCENDENT",
  7: "UNATTAINABLE",
  8: "NUMRARITYVALUES",
  9: "EFORTRARITY_MAX",
  10: "NEUTRAL",
};
